import { gql } from '@apollo/client';

export const VALIDATE_AND_OVERLAPS_BY_SEQUENCE_GROUP = gql`
	query ValidateAndOverlapsBySequenceGroup(
		$crewMemberId: ID!
		$workAssignmentSequenceGroupId: ID!
		$fromStationId: ID!
		$toStationId: ID!
		$activityType: ActivityType!
	) {
		eligibility: eligibilityValidation(
			crewMemberId: $crewMemberId
			workAssignmentSequenceGroupId: $workAssignmentSequenceGroupId
			fromStationId: $fromStationId
			toStationId: $toStationId
			activityType: $activityType
		) {
			failedRule
			defaultMessage
		}

		overlaps: overlappingCrewMemberActivitiesV2(
			crewMemberId: $crewMemberId
			workAssignmentSequenceGroupId: $workAssignmentSequenceGroupId
			fromStationId: $fromStationId
			toStationId: $toStationId
		) {
			overlappingActivities {
				fromTimestamp
				toTimestamp
				isCancellable
				activity {
					... on CrewMemberWorkAssignmentActivityItem {
						activityType
						fromStation {
							name
							code
							timezone
							city {
								name
							}
						}
						toStation {
							name
							code
							timezone
							city {
								name
							}
						}
					}
					... on CrewMemberAbsenceActivityItem {
						note
						reason {
							id
							name
						}
					}
				}
			}
			minDelayMinutes
			maxDelayMinutes
		}
	}
`;
